module.exports = __webpack_public_path__ + "app-static/img/04.d33dbf89.jpg";